{
  "carrierLabel": "कैरियर कंपनी",
  "searchPlaceholder": "नाम से खोजें",
  "selectAsCarrier": "\"{name}\" को कैरियर के रूप में चुनें",
  "typeToSearch": "किसी कंपनी के लिए खोजने हेतु टाइप करें"
}
